export enum Language {
  HR = "hr",
  EN = "en",
  IT = "it",
  DE = "de",
  SL = "sl",
  SR = "sr",
}
